module.exports = __webpack_public_path__ + "static/img/news-icon.bc226e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news-icon.jpg
// module id = E81Z
// module chunks = 1